/* eslint-disable react-hooks/exhaustive-deps */
// React Imports
import { useEffect, useState, useRef } from "react";

/* Css Imports */
import "./index.css";

/* Svg Imports */
import ICONS from "../../../../../assets/Icons";

/* Component Imports */
import TextInputField from "../../../../_utils/CommonInputFields/TextInputField";
import SingleSelectDropDownComponent from "../../../../_utils/CommonDropdown/SingleSelectDropdown";
import PrimaryButton from "../../../../_utils/CommonButtons/PrimaryButton";
import IconRoundButton from "../../../../_utils/CommonButtons/IconRoundButton";
import CommonToggle from "../../../../_utils/CommonToggle";
import SVGComponent from "../../../../_utils/SVGComponent";

/* Utils Imports */
import {
  CategoryFieldConfiguration,
  GlobalConfiguration,
} from "../../../../../utils/configurationProvider";
import TEXT from "../../../../../utils/globalText";

const AddCategoryField = ({
  isAddButtonClicked,
  setIsAddButtonClicked,
  editIndex,
  setEditIndex,
  fieldName,
  setFieldName,
  fieldType,
  setFieldType,
  toggleDescription,
  setToggleDescription,
  fieldMandatory,
  setFieldMandatory,
  options,
  setOptions,
  fieldDetails,
  setFieldDetails,
  isClearActive,
  setIsClearActive,
  isConfirmActive,
  setIsConfirmActive,
  showDeletePopup,
  setShowDeletePopup,
  setDeleteFieldIndex,
  paginationDivHeight,
  fieldDataArrayAreSimilar,
  flow,
  scrollRef,
  handleScrollToBottom
}) => {
  const [editValues, setEditValues] = useState({
    name: "",
    data_type: "",
    description: "",
    mandatory: false,
    data: [],
  });

  const dragItemIndex = useRef(null);
  const fieldDragItemIndex = useRef(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [fieldDragOverIndex, setFieldDragOverIndex] = useState(null);
  const [originalFieldType, setOriginalFieldType] = useState(null);
  const [editFieldType, setEditFieldType] = useState("");
  const [isEditFieldNameFocused, setIsEditFieldNameFocused] = useState(false);
  const [isFieldNameFocused, setIsFieldNameFocused] = useState(false);
  const [isEditDescriptionFocused, setIsEditDescriptionFocused] =
    useState(false);
  const [isToggleDescriptionFocused, setIsToggleDescriptionFocused] =
    useState(false);

  const [focusedEditOptionIndex, setFocusedEditOptionIndex] = useState(null);
  const [focusedOptionIndex, setFocusedOptionIndex] = useState(null);
  const nonToggleDataType = TEXT?.ADDITIONAL_DETAILS_DATA_TYPE?.filter((item) => item !== TEXT?.TOGGLE?.toLowerCase())

  /* FIELD TYPE OPTIONS */
  const field_type_options = CategoryFieldConfiguration?.fieldOptions.map(
    (obj) => Object.keys(obj)[0],
  );

  const getFieldKeyByValue = (value) => {
    const found = CategoryFieldConfiguration?.fieldOptions?.find((option) =>
      Object.values(option).includes(value),
    );
    return found ? Object.keys(found)[0] : null;
  };

  // Note - numeric,date,month_year - not mapped in configurationProvider

  const handleFieldNameChange = (val) => {
    const newVal = val.trimStart();
    const regex = /^.*$/;
    if (
      newVal?.length <= GlobalConfiguration?.categorymaxLength &&
      regex.test(newVal)
    ) {
      setFieldName(newVal);
    }
  };

  const handleFieldTypeChange = (val) => {
    setFieldType(val);
  };

  const handleToggleDescriptionChange = (val) => {
    const newVal = val.trimStart();
    const regex = /^.*$/;
    if (
      regex.test(newVal) &&
      newVal?.length <= GlobalConfiguration?.inputMaxLength
    ) {
      setToggleDescription(newVal);
    }
  };

  const addOption = () => {
    setOptions([...options, { id: Date.now(), value: "" }]);
  };

  const updateOption = (index, newValue) => {
    const cleanValue = newValue.trimStart();
    const regex = /^.*$/;
    if (
      regex.test(cleanValue) &&
      cleanValue.length <= GlobalConfiguration?.categorymaxLength
    ) {
      const updated = [...options];
      updated[index].value = cleanValue;
      setOptions(updated);
    }
  };

  const deleteOption = (id) => {
    setOptions(options?.filter((opt) => opt?.id !== id));
  };

  const handleDragStart = (index) => {
    dragItemIndex.current = index;
  };

  const handleDragEnter = (index) => {
    setDragOverIndex(index);
  };

  const handleDrop = () => {
    if (dragItemIndex.current === null || dragOverIndex === null) return;

    if (editIndex === null) {
      // Add mode
      const reordered = [...options];
      const [moved] = reordered?.splice(dragItemIndex.current, 1);
      reordered?.splice(dragOverIndex, 0, moved);
      setOptions(reordered);
    } else {
      // Update mode
      setEditValues((prev) => {
        const reordered = [...prev.data];
        const [moved] = reordered.splice(dragItemIndex.current, 1);
        reordered.splice(dragOverIndex, 0, moved);
        return { ...prev, data: reordered };
      });
    }

    // reset drag state
    dragItemIndex.current = null;
    setDragOverIndex(null);
  };

  const handleFieldDragStart = (index) => {
    fieldDragItemIndex.current = index;
  };

  const handleFieldDragEnter = (index) => {
    setFieldDragOverIndex(index);
  };

  const handleFieldDrop = () => {
    if (fieldDragItemIndex.current === null || fieldDragOverIndex === null)
      return;

    const reordered = [...fieldDetails];
    const [movedField] = reordered.splice(fieldDragItemIndex.current, 1);
    reordered.splice(fieldDragOverIndex, 0, movedField);

    const updatedFields = reordered.map((field, index) => ({
      ...field,
      position: index + 1,
    }));

    setFieldDetails(updatedFields);

    fieldDragItemIndex.current = null;
    setFieldDragOverIndex(null);
  };

  const clearCategoryField = () => {
    if (editIndex === null) {
      // Add mode
      setFieldName("");
      setFieldType("");
      setToggleDescription("");
      setFieldMandatory(false);
      setOptions([{ id: Date.now(), value: "" }]);
      setIsConfirmActive(false);
      setIsClearActive(false);
    } else if (isClearActive) {
      setEditFieldType("");
      setEditValues((prev) => ({
        ...prev,
        name: "",
        data_type: "",
        mandatory: false,
        description: "",
        data: Array.isArray(prev?.data) ? prev?.data?.map(() => "") : [],
      }));
      setIsConfirmActive(false);
      setIsClearActive(false);
    }
  };

  const confirmCategoryField = () => {
    if (editIndex === null) {
      // ------------ Add Mode --------------//
      const newField = {
        name: fieldName,
        position: fieldDetails?.length + 1,
        data_type: CategoryFieldConfiguration?.fieldOptions?.find(
          (obj) => fieldType in obj,
        )[fieldType],
        mandatory: fieldMandatory ? "Y" : "N",
        ...(toggleDescription && { description: toggleDescription }),
        ...(options &&
          Array.isArray(options) &&
          options.some((opt) => opt?.value?.trim() !== "") && {
            data: options?.map((opt) => opt?.value?.trim()),
          }),
      };
      setFieldDetails((prev) => [...prev, newField]);
      setIsAddButtonClicked(false);
      clearCategoryField();
    } else {
      // ---------- Edit Mode ---------- //
      const { name, data_type, description, data } = editValues || {};
      const minLength = GlobalConfiguration?.lengthCheckZero || 0;

      const nameValid = name?.trim() !== "";
      const typeValid = data_type?.trim() !== "";

      const descriptionValid =
        data_type !== TEXT?.TOGGLE?.toLowerCase() ||
        (description !== undefined && description?.trim() !== "");

      const dataValid =
        !nonToggleDataType?.includes(data_type) ||
        (Array.isArray(data) &&
          data.length > minLength &&
          data.every((val) => val?.trim() !== ""));

      if (
        isConfirmActive &&
        nameValid &&
        typeValid &&
        descriptionValid &&
        dataValid
      ) {
        setFieldDetails((prev) => {
          const updated = [...prev];

          const isListType =
            editValues?.data_type === TEXT?.LIST ||
            editValues?.data_type === TEXT?.MULTI_SELECT_LIST;

          const isToggleType = editValues?.data_type === TEXT?.TOGGLE?.toLowerCase();

          // Base object
          const newField = {
            ...updated[editIndex],
            ...editValues,
            mandatory: editValues?.mandatory ? "Y" : "N",
          };

          // Handle data field
          if (isListType) {
            newField.data =
              Array.isArray(editValues?.data) &&
              editValues.data.some((v) => v?.trim() !== "")
                ? editValues.data.map((v) => v.trim()).filter((v) => v !== "")
                : [];
          } else {
            delete newField.data; // remove old data if not list type
          }

          // Handle description field
          if (isToggleType) {
            newField.description = editValues?.description?.trim() || "";
          } else {
            delete newField.description; // remove old description if not toggle type
          }

          updated[editIndex] = newField;
          return updated;
        });

        // reset edit mode only if update happened
        setEditIndex(null);
        setEditValues({
          name: "",
          data_type: "",
          description: "",
          mandatory: false,
          data: [],
        });
      }
    }
  };

  const handleAddFields = () => {
    if (editIndex === null || editIndex === undefined) {
      setIsAddButtonClicked(true);
    }
  };

  const handleAddNewOption = () =>
    setEditValues((prev) => ({
      ...prev,
      data: prev?.data ? [...prev?.data, ""] : ["", ""],
    }));

  const computeVariant = ({
    value,
    focused,
    minLength,
    maxLength,
    shouldValidate = true,
  }) => {
    if (!shouldValidate) {
      return TEXT?.DEFAULT_SMALL;
    }

    const trimmedLength = (value ?? "").trim().length;
    const actualLength = (value ?? "").length;

    // Empty input
    if (trimmedLength === GlobalConfiguration?.lengthCheckZero) {
      return focused ? TEXT?.TYPING : TEXT?.DEFAULT_SMALL;
    }

    // Valid range
    if (actualLength >= minLength && actualLength <= maxLength) {
      return TEXT?.VERIFIED_SMALL;
    }

    // Below minimum length
    if (actualLength < minLength) {
      return focused ? TEXT?.TYPING : TEXT?.ERROR;
    }

    // Exceeds max length
    if (actualLength > maxLength) {
      return TEXT?.ERROR;
    }

    return TEXT?.DEFAULT_SMALL;
  };

  useEffect(() => {
    const matchedOption = CategoryFieldConfiguration?.fieldOptions?.find(
      (obj) => editFieldType in obj,
    );

    if (editFieldType && matchedOption) {
      setEditValues((prev) => ({
        ...prev,
        data_type: matchedOption[editFieldType],
      }));
    }

    if (!editFieldType) {
      setEditValues((prev) => ({
        ...prev,
        data_type: "",
      }));
    }
  }, [editFieldType, CategoryFieldConfiguration]);

  useEffect(() => {
    if (fieldDataArrayAreSimilar && flow === "edit") return;
    const handleBeforeUnload = (event) => {
      if (fieldDetails.length) {
        event.preventDefault();
        event.returnValue = ""; // Triggers default browser warning
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [fieldDetails, fieldDataArrayAreSimilar]);

  useEffect(() => {
    setToggleDescription("");
    setOptions([{ id: Date.now(), value: "" }]);
  }, [fieldType]);

  useEffect(() => {
    if (!isAddButtonClicked && editIndex == null) return;
    if (fieldDetails?.length - GlobalConfiguration?.lengthCheckOne === editIndex || isAddButtonClicked) {
      requestAnimationFrame(() => {
        handleScrollToBottom();
      });
    }
  }, [isAddButtonClicked, editIndex]);

  useEffect(() => {
    const isEditing = editIndex != null;
    const currentFieldName = (fieldName || "").trim();
    const currentFieldType = (fieldType || "").trim();
    const currentToggleDescription =
      typeof toggleDescription === "string" ? toggleDescription?.trim() : "";

    const hasAnyInput =
      currentFieldName !== "" ||
      currentFieldType !== "" ||
      (currentToggleDescription !== "" &&
        currentToggleDescription?.length >
          GlobalConfiguration?.lengthCheckTwo) ||
      fieldMandatory === true ||
      (options && options?.some((opt) => (opt?.value || "").trim() !== ""));

    setIsClearActive(hasAnyInput);

    if (!isEditing) {
      let isDuplicate = false;

      if (fieldDetails.length) {
        isDuplicate = fieldDetails?.some(
          (field) =>
            field?.name === currentFieldName &&
            getFieldKeyByValue(field?.data_type) === currentFieldType,
        );
      }

      if (isDuplicate) {
        setIsConfirmActive(false);
        setIsClearActive(true);
        return;
      }

      const fieldName_fieldType_check =
        currentFieldName !== "" &&
        currentFieldName.length >= GlobalConfiguration?.lengthCheckThree &&
        currentFieldType !== "";

      let allFilled = false;

      if (
        fieldType === field_type_options[2] ||
        fieldType === field_type_options[3]
      ) {
        if (
          fieldName_fieldType_check &&
          options &&
          options?.length > GlobalConfiguration?.lengthCheckZero &&
          options?.every(
            (opt) =>
              (opt?.value || "")?.trim().length >
              GlobalConfiguration?.lengthCheckTwo,
          ) &&
          new Set(options?.map((opt) => (opt?.value || "")?.trim())).size ===
            options?.length
        ) {
          allFilled = true;
        }
      } else if (
        fieldType === field_type_options[GlobalConfiguration?.ifscLength]
      ) {
        if (
          fieldName_fieldType_check &&
          currentToggleDescription !== "" &&
          currentToggleDescription?.length > GlobalConfiguration?.lengthCheckTwo
        ) {
          allFilled = true;
        }
      } else {
        if (fieldName_fieldType_check) allFilled = true;
      }

      setIsConfirmActive(allFilled);
    } else {
      const currentEditedName = (editValues?.name || "").trim();
      const currentEditedTypeRaw = editValues?.data_type ?? "";
      const currentEditedMandatory = editValues?.mandatory ? "Y" : "N";
      const currentEditedTypeKey = getFieldKeyByValue(currentEditedTypeRaw);
      const currentEditedDescription = (editValues?.description || "")?.trim();
      const currentEditedData = Array.isArray(editValues?.data)
        ? editValues?.data?.map((v) => (v || "")?.trim())
        : [];
      const fieldDetailsNameCheck =
        fieldDetails[editIndex].name === currentEditedName;
      const fieldDetailEditTypeCheck =
        fieldDetails[editIndex].data_type === currentEditedTypeRaw;
      const fieldDetailEditMandatoryCheck =
        fieldDetails[editIndex].mandatory === currentEditedMandatory;
      const fieldDetailDataTypeCheck =
        fieldDetails[editIndex].data_type === TEXT?.TOGGLE?.toLowerCase();
      const fieldDetailDescriptionCheck =
        fieldDetails[editIndex].description === currentEditedDescription;

      if (
        !currentEditedName ||
        !currentEditedTypeRaw ||
        (!TEXT?.ADDITIONAL_DETAILS_DATA_TYPE?.includes(
          fieldDetails[editIndex].data_type,
        ) &&
          fieldDetailsNameCheck &&
          fieldDetailEditTypeCheck &&
          fieldDetailEditMandatoryCheck) ||
        (fieldDetails[editIndex] &&
          fieldDetailsNameCheck &&
          fieldDetailEditTypeCheck &&
          fieldDetailEditMandatoryCheck &&
          ((fieldDetailDataTypeCheck && fieldDetailDescriptionCheck) ||
            (nonToggleDataType?.includes(
              fieldDetails[editIndex].data_type,
            ) &&
              fieldDetails[editIndex].data.length ===
                currentEditedData.length &&
              fieldDetails[editIndex].data.every(
                (opt, idx) => opt === currentEditedData[idx],
              ))))
      ) {
        setIsConfirmActive(false);
        const hasAnyInputFromEdit =
          currentEditedName !== "" ||
          currentEditedTypeRaw !== "" ||
          (currentEditedDescription !== "" &&
            currentEditedDescription?.length >
              GlobalConfiguration?.lengthCheckTwo) ||
          (currentEditedData.length > GlobalConfiguration?.lengthCheckZero &&
            currentEditedData.some((val) => val !== ""));
        setIsClearActive(hasAnyInputFromEdit);
        return;
      }

      let isDuplicate = false;
      if (fieldDetails?.length > GlobalConfiguration?.lengthCheckZero) {
        isDuplicate = fieldDetails.some(
          (field) =>
            field?.position !==
              editIndex + GlobalConfiguration?.lengthCheckOne &&
            (field?.name || "").trim() === currentEditedName &&
            getFieldKeyByValue(field?.data_type) === currentEditedTypeKey,
        );
      }

      if (isDuplicate) {
        setIsConfirmActive(false);
        setIsClearActive(true);
        return;
      }

      let allFilled = false;

      if (
        currentEditedTypeKey === field_type_options[2] ||
        currentEditedTypeKey === field_type_options[3]
      ) {
        if (
          currentEditedName !== "" &&
          currentEditedData?.length > GlobalConfiguration?.lengthCheckZero &&
          currentEditedData.every((v) => v !== "") &&
          currentEditedData.every(
            (val) => val.trim().length > GlobalConfiguration?.lengthCheckTwo,
          ) &&
          new Set(currentEditedData).size === currentEditedData?.length
        ) {
          allFilled = true;
        }
      } else if (
        currentEditedTypeKey ===
        field_type_options[GlobalConfiguration?.ifscLength]
      ) {
        if (
          currentEditedName !== "" &&
          currentEditedName?.length >= GlobalConfiguration.lengthCheckThree &&
          currentEditedDescription !== "" &&
          currentEditedDescription?.length >=
            GlobalConfiguration.lengthCheckThree
        ) {
          allFilled = true;
        }
      } else {
        if (
          currentEditedName !== "" &&
          currentEditedName?.length >= GlobalConfiguration.lengthCheckThree
        ) {
          allFilled = true;
        }
      }

      setIsConfirmActive(allFilled);
      setIsClearActive(true);
    }
  }, [
    fieldName,
    fieldType,
    toggleDescription,
    fieldMandatory,
    options,
    fieldDetails,
    editValues,
    editIndex,
  ]);

  return (
    <>
      <div className="flex flex-1 w-width-full bg-primary-bg overflow-y-auto"
      ref={scrollRef}>
        {/* ------------------------------ */}

        <div className="w-width-full bg-primary-bg">
          <div className="mx-auto w-width-full Qmd:max-w-tab-width-normal flex flex-col gap-y-gap-md p-padding-base Qmd:gap-x-gap-xl Qmd:pt-padding-lg pt-padding-base pb-padding-md items-start bg-primary-bg">
            {/* Add field button for category*/}
            <div className="w-width-full Qmd:px-padding-md Qlg:px-padding-base">
              <div
                className={`w-width-full py-padding-md px-padding-sm gap-y-gap-xs flex flex-col justify-center items-center rounded-none Qmd:rounded-border-radius-md bg-primary-nav-act ${isAddButtonClicked || (editIndex !== null && editIndex !== undefined) ? "opacity-light-opacity cursor-not-allowed" : "cursor-pointer global-hover-white relative z-z-index-content"}`}
                onClick={handleAddFields}
              >
                <SVGComponent
                  url={ICONS?.ADD_BUTTON_WHITE}
                  alt={TEXT?.ADD_FIELD_FOR_CATEGORY}
                  height="var(--icon-lg)"
                  width="var(--icon-lg)"
                  color="var(--text-primary)"
                />

                <p className="text-font-sm text-text-primary font-semibold">
                  {TEXT.ADD_FIELD}
                </p>
              </div>
            </div>
            {/*-----------------------------*/}

            {/* STORED FIELD */}
            {Array.isArray(fieldDetails) &&
              fieldDetails?.length > GlobalConfiguration?.lengthCheckZero &&
              fieldDetails.some(() => true) && (
                <>
                  {fieldDetails?.map((field, index) => {
                    const isEditing = editIndex === index;
                    return (
                      <div className="w-width-full px-padding-md Qlg:px-padding-base">
                        <div
                          key={index}
                          className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md w-width-full"
                          draggable={
                            !isAddButtonClicked &&
                            (editIndex === null || editIndex === undefined)
                          } // Enable dragging when editing is not open
                          onDragStart={() => handleFieldDragStart(index)}
                          onDragEnter={() => handleFieldDragEnter(index)}
                          onDragEnd={handleFieldDrop}
                        >
                          <div className="flex flex-col">
                            <div className="flex flex-row items-center gap-x-gap-sm justify-between">
                              <div className="flex flex-row items-center gap-x-gap-sm">
                                <SVGComponent
                                  url={ICONS?.DRAG_INDICATOR}
                                  height={"var(--icon-md)"}
                                  width={"var(--icon-md)"}
                                  alt={TEXT?.DRAG_FIELD}
                                />
                                <p className="text-font-md text-text-primary font-semibold">
                                  {`${TEXT?.ADD_CATEGORY_FIELD} ${index + true} ${!isEditing && field?.mandatory === "Y" ? `(${TEXT?.MANDATORY})` : ""}`}
                                </p>
                              </div>
                              {isEditing ? (
                                <>
                                  <div className="flex flex-row justify-center items-center">
                                    <p className="text-font-xs text-text-secondary font-semibold">
                                      {TEXT?.MANDATORY_FIELD}
                                    </p>
                                    <div className="mx-margin-sm">
                                      <CommonToggle
                                        state={editValues?.mandatory}
                                        handleClick={() =>
                                          setEditValues((prev) => ({
                                            ...prev,
                                            mandatory: !prev?.mandatory,
                                          }))
                                        }
                                      />
                                    </div>
                                    <div className="close-field-btn pl-padding-sm border-l border-solid border-primary-bg">
                                      <IconRoundButton
                                        btnType={TEXT?.BUTTON}
                                        handleFunction={() => {
                                          setEditIndex(null);
                                          setEditValues({
                                            name: "",
                                            data_type: "",
                                            description: "",
                                            mandatory: false,
                                            data: [],
                                          });
                                        }}
                                        enabledBgColor="var(--primary-nav)"
                                        isLoading={false}
                                        icon={ICONS?.CLOSE}
                                        hoverOption={TEXT?.WHITE}
                                        title={TEXT?.CLOSE_FIELD}
                                      />
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="flex self-end gap-x-gap-sm">
                                    <IconRoundButton
                                        btnType={TEXT?.BUTTON}
                                      isDisabled={
                                        isAddButtonClicked ||
                                        (editIndex !== null &&
                                          editIndex !== undefined &&
                                          editValues)
                                          ? true
                                          : false
                                      }
                                      handleFunction={() => {
                                        if (
                                          !(
                                            isAddButtonClicked ||
                                            (editIndex !== null &&
                                              editIndex !== undefined &&
                                              editValues)
                                          )
                                        ) {
                                          setEditIndex(index);
                                          const field = fieldDetails[index];
                                          setEditFieldType(field?.data_type);
                                          setEditValues({
                                            name: field?.name,
                                            data_type: field?.data_type,
                                            mandatory: field?.mandatory === "Y",
                                            ...(field?.description
                                              ? {
                                                  description:
                                                    field?.description,
                                                }
                                              : {}),
                                            ...(field?.data
                                              ? { data: field?.data }
                                              : {}),
                                          });
                                          setOriginalFieldType(
                                            field?.data_type,
                                          );
                                        }
                                      }}
                                      enabledBgColor="var(--primary-nav)"
                                      isLoading={false}
                                      icon={ICONS?.EDIT}
                                      hoverOption={TEXT?.WHITE}
                                      title={TEXT?.EDIT_FIELD}
                                    />
                                    <IconRoundButton
                                      btnType={TEXT?.BUTTON}
                                      isDisabled={
                                        isAddButtonClicked ||
                                        (editIndex !== null &&
                                          editIndex !== undefined &&
                                          editValues)
                                      }
                                      handleFunction={() => {
                                        if (
                                          isAddButtonClicked ||
                                          (editIndex !== null &&
                                            editIndex !== undefined &&
                                            editValues)
                                        ) {
                                          return;
                                        }

                                        setDeleteFieldIndex(index);
                                        setShowDeletePopup(true);
                                      }}
                                      enabledBgColor="var(--primary-nav)"
                                      isLoading={false}
                                      icon={ICONS?.DELETE_WHITE_FILLED}
                                      hoverOption={TEXT?.WHITE}
                                      title={TEXT?.DELETE_FIELD}
                                    />
                                  </div>
                                </>
                              )}
                            </div>

                            <div className="flex flex-row flex-wrap Qmd:flex-nowrap gap-x-gap-md gap-y-gap-md items-end mt-margin-md">
                              <div className="flex flex-col gap-y-gap-xs w-width-full">
                                <TextInputField
                                  bgColor={
                                    showDeletePopup
                                      ? "var(--primary-bg)"
                                      : "var(--primary-card)"
                                  }
                                  fgColor={
                                    (isEditing && editValues?.name === "") ||
                                    field?.name === ""
                                      ? "var(--text-secondary)"
                                      : "var(--text-primary)"
                                  }
                                  fontKind="small"
                                  placeholder={TEXT?.ADDITIONAL_FIELD_LABEL}
                                  variant={computeVariant({
                                    value: editValues?.name,
                                    focused: isEditFieldNameFocused,
                                    minLength:
                                      GlobalConfiguration?.categoryminLength,
                                    maxLength:
                                      GlobalConfiguration?.categorymaxLength,
                                    shouldValidate: isEditing,
                                  })}
                                  onFocus={() =>
                                    setIsEditFieldNameFocused(true)
                                  }
                                  onBlur={() =>
                                    setIsEditFieldNameFocused(false)
                                  }
                                  value={
                                    isEditing ? editValues?.name : field?.name
                                  }
                                  isDisabled={!isEditing}
                                  onInput={(e) => {
                                    const { value } = e.target;
                                    const newVal = value.trimStart();
                                    if (
                                      /^.*$/.test(newVal) &&
                                      newVal.length <=
                                        GlobalConfiguration?.categorymaxLength
                                    ) {
                                      setEditValues((prev) => ({
                                        ...prev,
                                        name: newVal,
                                      }));
                                    }
                                  }}
                                  adornment=""
                                  isFullWidth={true}
                                />
                              </div>

                              <div className="flex flex-col gap-y-gap-xs">
                                <p className="text-font-xs text-text-secondary font-normal">
                                  {TEXT?.CATEGORY_FIELD_TYPE}
                                </p>
                                <div className="w-width-full min-w-min-field-type-width">
                                  <SingleSelectDropDownComponent
                                    options={field_type_options}
                                    selected={
                                      isEditing
                                        ? editValues?.data_type
                                          ? getFieldKeyByValue(
                                              editValues?.data_type,
                                            )
                                          : editFieldType
                                        : getFieldKeyByValue(field?.data_type)
                                    }
                                    placeholder={"Select"}
                                    setSelected={setEditFieldType}
                                    isOpen={false}
                                    showSearch={false}
                                    disabled={!isEditing}
                                    type="add_category_field"
                                  />
                                </div>
                              </div>
                            </div>

                            {(originalFieldType?.toLowerCase() ===
                              editValues?.data_type?.toLowerCase() &&
                              field?.description) ||
                            (editValues?.data_type?.toLowerCase() ===
                              TEXT?.TOGGLE?.toLowerCase() &&
                              editIndex === index) ||
                            (field?.description && editIndex !== index) ? (
                              <>
                                <div className="border-b border-solid border-primary-bg my-margin-md"></div>
                                <TextInputField
                                  bgColor="var(--primary-card)"
                                  fgColor={
                                    editValues?.description === ""
                                      ? "var(--text-secondary)"
                                      : "var(--text-primary)"
                                  }
                                  placeholder={TEXT?.TOGGLE_DESCRIPTION_LABEL}
                                  adornment=""
                                  variant={computeVariant({
                                    value: editValues?.description,
                                    focused: isEditDescriptionFocused,
                                    minLength:
                                      GlobalConfiguration?.categoryminLength,
                                    maxLength:
                                      GlobalConfiguration?.inputMaxLength,
                                    shouldValidate: isEditing,
                                  })}
                                  onFocus={() =>
                                    setIsEditDescriptionFocused(true)
                                  }
                                  onBlur={() =>
                                    setIsEditDescriptionFocused(false)
                                  }
                                  fontKind="small"
                                  value={
                                    isEditing
                                      ? editValues?.description
                                      : field?.description
                                  }
                                  onInput={(e) => {
                                    const { value } = e.target;
                                    const newVal = value.trimStart();
                                    if (
                                      /^.*$/.test(newVal) &&
                                      newVal.length <=
                                        GlobalConfiguration?.inputMaxLength
                                    ) {
                                      setEditValues((prev) => ({
                                        ...prev,
                                        description: newVal,
                                      }));
                                    }
                                  }}
                                  isDisabled={!isEditing}
                                  isFullWidth={true}
                                />
                              </>
                            ) : null}

                            {((originalFieldType?.toLowerCase() ===
                              editValues?.data_type?.toLowerCase() &&
                              field?.data) ||
                              ((editValues?.data_type?.toLowerCase() ===
                                TEXT?.LIST ||
                                editValues?.data_type?.toLowerCase() ===
                                  TEXT?.MULTI_SELECT_LIST) &&
                                editIndex === index) ||
                              (field?.data && editIndex !== index)) && (
                              <>
                                <div className="border-b border-solid border-primary-bg my-margin-md"></div>
                                <div className="flex flex-row flex-wrap gap-gap-md items-end">
                                  {(isEditing
                                    ? editValues.data
                                      ? editValues.data
                                      : [""]
                                    : field?.data
                                  )?.map((opt, index) => {
                                    const value = opt;
                                    return (
                                      <div
                                        key={index}
                                        className="flex flex-row items-center"
                                        draggable={isEditing}
                                        onDragStart={() =>
                                          isEditing && handleDragStart(index)
                                        }
                                        onDragEnter={() =>
                                          isEditing && handleDragEnter(index)
                                        }
                                        onDragEnd={
                                          isEditing ? handleDrop : undefined
                                        }
                                      >
                                        {isEditing && (
                                          <SVGComponent
                                            url={ICONS?.DRAG_INDICATOR}
                                            height={"var(--icon-md)"}
                                            width={"var(--icon-md)"}
                                            alt={TEXT?.DRAG_OPTION}
                                          />
                                        )}
                                        <TextInputField
                                          bgColor="var(--primary-card)"
                                          fgColor={
                                            value === ""
                                              ? "var(--text-secondary)"
                                              : "var(--text-primary)"
                                          }
                                          placeholder={`Option ${index + true} (3-20 char)`}
                                          adornment={
                                            isEditing ? ICONS?.CLOSE : ""
                                          }
                                          onAdornmentClick={
                                            isEditing
                                              ? () =>
                                                  setEditValues((prev) => ({
                                                    ...prev,
                                                    data: prev?.data?.filter(
                                                      (_, i) => i !== index,
                                                    ),
                                                  }))
                                              : undefined
                                          }
                                          variant={computeVariant({
                                            value,
                                            focused:
                                              focusedEditOptionIndex === index,
                                            minLength:
                                              GlobalConfiguration?.categoryminLength,
                                            maxLength:
                                              GlobalConfiguration?.categorymaxLength,
                                            shouldValidate: isEditing,
                                          })}
                                          onFocus={() =>
                                            setFocusedEditOptionIndex(index)
                                          }
                                          onBlur={() =>
                                            setFocusedEditOptionIndex(null)
                                          }
                                          fontKind="small"
                                          value={value || ""}
                                          onInput={(e) => {
                                            const value =
                                              e.target.value.trimStart();
                                            if (
                                              isEditing &&
                                              /^.*$/.test(value) &&
                                              value.length <=
                                                GlobalConfiguration?.categorymaxLength
                                            ) {
                                              setEditValues((prev) => {
                                                let updated = prev?.data
                                                  ? [...prev.data]
                                                  : [];

                                                updated[index] = value;

                                                return {
                                                  ...prev,
                                                  data: updated,
                                                };
                                              });
                                            }
                                          }}
                                          isDisabled={!isEditing}
                                          isFullWidth={true}
                                        />
                                      </div>
                                    );
                                  })}

                                  {/* Add New Option */}
                                  {isEditing && (
                                    <div
                                      className="flex flex-col cursor-pointer"
                                      onClick={handleAddNewOption}
                                    >
                                      <div />
                                      <div className="w-options-width flex items-center py-padding-sm px-padding-md rounded-border-radius-md bg-primary-nav-act">
                                        <div className="flex flex-row items-center justify-center gap-x-gap-sm">
                                          <SVGComponent
                                            url={ICONS?.ADD_BUTTON_WHITE}
                                            height={"var(--icon-md)"}
                                            width={"var(--icon-md)"}
                                            color="var(--text-primary)"
                                            alt={TEXT?.ADD_OPTION}
                                          />

                                          <p className="text-font-xs text-text-primary font-normal">
                                            {TEXT?.ADD_OPTION}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </>
                            )}

                            {isEditing && (
                              <div className="flex flex-row gap-x-gap-sm justify-end items-center mt-margin-md">
                                <PrimaryButton
                                  btnText={TEXT?.CLEAR}
                                  isDisabled={isClearActive ? false : true}
                                  enabledBgColor=""
                                  enabledTextColor="var(--text-primary)"
                                  outLineColor="var(--text-primary)"
                                  handleFunction={() =>
                                    clearCategoryField(index)
                                  }
                                  hoverOption={TEXT?.WHITE}
                                />
                                <PrimaryButton
                                  btnText={TEXT?.CONFIRM}
                                  isDisabled={isConfirmActive ? false : true}
                                  inActiveVariantNeeded
                                  enabledTextColor="var(--primary-bg)"
                                  enabledBgColor="var(--text-primary)"
                                  disabledBgColor="var(--text-disabled)"
                                  disabledTextColor="var(--text-primary)"
                                  handleFunction={() => {
                                    if (isConfirmActive) {
                                      confirmCategoryField(index);
                                    }
                                  }}
                                  hoverOption={TEXT?.BLACK}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </>
              )}

            {isAddButtonClicked && (
              <div className="w-width-full px-padding-md Qlg:px-padding-base">
                <div className="flex flex-col bg-primary-card p-padding-md rounded-border-radius-md w-width-full">
                  <div className="flex flex-row justify-between">
                    <div className="flex flex-row gap-x-gap-sm items-center">
                      <SVGComponent
                        url={ICONS?.DRAG_INDICATOR}
                        height={"var(--icon-md)"}
                        width={"var(--icon-md)"}
                        alt={TEXT?.CATEGORY_FIELD}
                      />

                      <p className="text-font-md text-text-primary font-semibold">
                        {`${TEXT?.ADD_CATEGORY_FIELD} ${fieldDetails?.length + true}`}
                      </p>
                    </div>
                    <div className="flex flex-row justify-center items-center">
                      <p className="text-font-xs text-text-secondary font-semibold">
                        {TEXT?.MANDATORY_FIELD}
                      </p>
                      <div className="mx-margin-sm">
                        <CommonToggle
                          state={fieldMandatory}
                          handleClick={() => setFieldMandatory(!fieldMandatory)}
                        />
                      </div>
                      <div className="close-field-btn pl-padding-sm border-l border-solid border-primary-bg">
                        <IconRoundButton
                          btnType={TEXT?.BUTTON}
                          handleFunction={() => {
                            setIsAddButtonClicked(false);
                            setFieldType("");
                            setFieldName("");
                            setFieldMandatory(false);
                          }}
                          enabledBgColor="var(--primary-nav)"
                          isLoading={false}
                          icon={ICONS?.CLOSE}
                          hoverOption={TEXT?.WHITE}
                          title={TEXT?.CLOSE_FIELD}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Field Name & Field Type*/}
                  <div className="flex flex-row flex-wrap Qmd:flex-nowrap gap-x-gap-md gap-y-gap-md items-end mt-margin-md">
                    <div className="flex flex-col gap-y-gap-xs mt-margin-md w-width-full">
                      <TextInputField
                        bgColor="var(--primary-card)"
                        fgColor={
                          fieldName === ""
                            ? "var(--text-secondary)"
                            : "var(--text-primary)"
                        }
                        placeholder={TEXT?.ADDITIONAL_FIELD_LABEL}
                        variant={computeVariant({
                          value: fieldName?.trim(),
                          focused: isFieldNameFocused,
                          minLength: GlobalConfiguration?.categoryminLength,
                          maxLength: GlobalConfiguration?.categorymaxLength,
                        })}
                        onFocus={() => setIsFieldNameFocused(true)}
                        onBlur={() => setIsFieldNameFocused(false)}
                        fontKind="small"
                        value={fieldName}
                        onInput={(e) => handleFieldNameChange(e.target.value)}
                        adornment=""
                        isFullWidth={true}
                      />
                    </div>

                    <div className="flex flex-col gap-y-gap-xs">
                      <p className="text-font-xs text-text-secondary font-normal">
                        {TEXT?.CATEGORY_FIELD_TYPE}
                      </p>
                      <div className="w-width-full min-w-min-field-type-width">
                        <SingleSelectDropDownComponent
                          options={field_type_options}
                          selected={fieldType}
                          setSelected={handleFieldTypeChange}
                          isOpen={false}
                          showSearch={false}
                          placeholder={TEXT?.SELECT}
                          type="add_category_field"
                        />
                      </div>
                    </div>
                  </div>
                  {/*---------------------*/}

                  {(fieldType === TEXT?.SINGLE_SELECT_DROPDOWN ||
                    fieldType === TEXT?.MULTI_SELECT_DROPDOWN) && (
                    <>
                      <div className="border-b border-solid border-primary-bg my-margin-md"></div>
                      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-y-gap-md gap-x-gap-sm w-width-full">
                        {options?.map((opt, index, arr) => (
                          <div
                            key={opt.id}
                            className="flex flex-row items-center gap-x-gap-xs"
                            draggable
                            onDragStart={() => handleDragStart(index)}
                            onDragEnter={() => handleDragEnter(index)}
                            onDragEnd={handleDrop}
                          >
                            <SVGComponent
                              url={ICONS?.DRAG_INDICATOR}
                              height={"var(--icon-md)"}
                              width={"var(--icon-md)"}
                              alt={TEXT?.DRAG_OPTION}
                            />
                            <TextInputField
                              bgColor="var(--primary-card)"
                              fgColor={
                                opt?.value === ""
                                  ? "var(--text-secondary)"
                                  : "var(--text-primary)"
                              }
                              placeholder={`Option ${index + true} (3-20 char)`}
                              adornment={
                                arr.length > GlobalConfiguration?.lengthCheckOne
                                  ? ICONS?.CLOSE
                                  : ""
                              }
                              onAdornmentClick={
                                arr.length > GlobalConfiguration?.lengthCheckOne
                                  ? () => deleteOption(opt?.id)
                                  : undefined
                              }
                              variant={computeVariant({
                                value: opt?.value?.trim(),
                                focused: focusedOptionIndex === index,
                                minLength:
                                  GlobalConfiguration?.categoryminLength,
                                maxLength:
                                  GlobalConfiguration?.categorymaxLength,
                              })}
                              onFocus={() => setFocusedOptionIndex(index)}
                              onBlur={() => setFocusedOptionIndex(null)}
                              fontKind="small"
                              value={opt?.value}
                              onInput={(e) =>
                                updateOption(index, e.target.value)
                              }
                              isFullWidth={true}
                            />
                          </div>
                        ))}

                        {/* Add New Option */}
                        <div
                          className="flex flex-col cursor-pointer"
                          onClick={addOption}
                        >
                          <div />
                          <div className="w-options-width flex items-center py-padding-sm px-padding-md rounded-border-radius-md bg-primary-nav-act">
                            <div className="flex flex-row items-center justify-center gap-x-gap-sm">
                              <SVGComponent
                                url={ICONS?.ADD_BUTTON_WHITE}
                                height={"var(--icon-md)"}
                                width={"var(--icon-md)"}
                                color="var(--text-primary)"
                                alt={TEXT?.ADD_OPTION}
                              />
                              <p className="text-font-xs text-text-primary font-normal">
                                {TEXT?.ADD_OPTION}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}

                  {fieldType === TEXT?.TOGGLE && (
                    <>
                      <div className="border-b border-solid border-primary-bg my-margin-md"></div>
                      <TextInputField
                        bgColor="var(--primary-card)"
                        fgColor={
                          toggleDescription === ""
                            ? "var(--text-secondary)"
                            : "var(--text-primary)"
                        }
                        placeholder={TEXT?.TOGGLE_DESCRIPTION_LABEL}
                        adornment=""
                        variant={computeVariant({
                          value: toggleDescription,
                          focused: isToggleDescriptionFocused,
                          minLength: GlobalConfiguration?.categoryminLength,
                          maxLength: GlobalConfiguration?.inputMaxLength,
                        })}
                        onFocus={() => setIsToggleDescriptionFocused(true)}
                        onBlur={() => setIsToggleDescriptionFocused(false)}
                        fontKind="small"
                        value={toggleDescription}
                        onInput={(e) =>
                          handleToggleDescriptionChange(e.target.value)
                        }
                        isFullWidth={true}
                      />
                    </>
                  )}

                  <div className="flex flex-row gap-x-gap-sm justify-end items-center mt-margin-md">
                    <PrimaryButton
                      btnText={TEXT?.CLEAR}
                      isDisabled={isClearActive ? false : true}
                      enabledBgColor=""
                      enabledTextColor="var(--text-primary)"
                      outLineColor="var(--text-primary)"
                      handleFunction={clearCategoryField}
                      hoverOption={TEXT?.WHITE}
                    />
                    <PrimaryButton
                      btnText={TEXT?.CONFIRM}
                      isDisabled={isConfirmActive ? false : true}
                      inActiveVariantNeeded
                      enabledTextColor="var(--primary-bg)"
                      enabledBgColor="var(--text-primary)"
                      disabledBgColor="var(--text-disabled)"
                      disabledTextColor="var(--text-primary)"
                      handleFunction={() => {
                        if (isConfirmActive) {
                          confirmCategoryField();
                        }
                      }}
                      hoverOption={TEXT?.BLACK}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="h-stepper-moble-height block Qmd:hidden"></div>
    </>
  );
};

export default AddCategoryField;
